export default __webpack_public_path__ + "static/media/small_search_black.09289025.svg";